export const EVENT_STATUSES = {
    active: 'active',
    inactive: 'inactive',
    expired: 'expired',
    pendingApproval: 'pendingApproval',
};
export const EVENT_STATUSES_FILTER = {
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    pendingApproval: 'Pending approval',
};
/** The number of hours after the event date to consider the attendance window. */
export const ATTENDANCE_WINDOW_HOURS_AFTER_EVENT = 12;
